"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeShort1Schema = void 0;
exports.YoutubeShort1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/youtube-short/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "YoutubeShort1",
    "description": "YouTube Shorts presents user-generated vertical or square videos up to 60 seconds long.",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:youtube-short:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "shortId": {
                    "type": "string",
                    "description": "The unique identifier of the short video."
                }
            },
            "required": [
                "shortId"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy95b3V0dWJlLXNob3J0LzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsbUJBQW1CLEdBQUc7SUFDakMsS0FBSyxFQUFFLGtGQUFrRjtJQUN6RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxlQUFlO0lBQ3hCLGFBQWEsRUFBRSx5RkFBeUY7SUFDeEcsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLDBDQUEwQzthQUMzQztTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsWUFBWSxFQUFFO2dCQUNaLFNBQVMsRUFBRTtvQkFDVCxNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLDJDQUEyQztpQkFDM0Q7YUFDRjtZQUNELFVBQVUsRUFBRTtnQkFDVixTQUFTO2FBQ1Y7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==